import { createContext, useContext, type ReactNode } from 'react';

export type TimeFormatValue = '24h' | '12h';

interface DateTimeContextValue {
  timeFormat: TimeFormatValue;
}

const DateTimeContext = createContext<DateTimeContextValue>({
  timeFormat: '24h',
});

export function DateTimeFormatProvider({
  timeFormat,
  children,
}: {
  timeFormat: TimeFormatValue;
  children: ReactNode;
}) {
  return (
    <DateTimeContext.Provider value={{ timeFormat }}>
      {children}
    </DateTimeContext.Provider>
  );
}

export function useDateTimeFormat(): DateTimeContextValue {
  return useContext(DateTimeContext);
}
